// @flow
/** @jsx h */

import { h } from 'preact'
import styles from '../../ResultItem.css'
import { bem } from '../../../../../../../../helpers/bem'

type Props = {
  scorePercent: number,
  hidden?: boolean
}

export function Percent ({ scorePercent, hidden = false }: Props) {
  const shouldTransform = false
  const transform = shouldTransform ? getTransform(scorePercent) : {}

  return (
    <div className={bem(styles['resultItem__score'], hidden ? 'hidden' : '')} style={transform}>
      <span className={styles['resultItem__score-text']}>
        {prettyPrintScorePercent(scorePercent)}
      </span>
    </div>
  )
}

function prettyPrintScorePercent (scorePercent): string {
  return `${scorePercent.toFixed(0)} %`
}

function getTransform (width: number, transitionDelayMs: number = 20): Object {
  // Ensure bars get a certain width
  if (width < 5) {
    width = 5
  }
  const transform = `translateX(-${100 - width}%)`
  return {
    left: 40,
    WebkitTransform: transform,
    MozTransform: transform,
    msTransform: transform,
    OTransform: transform,
    transform,
    transitionDelay: '20ms'
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Result/components/ResultList/components/ResultItem/components/Percent/Percent.js